import cls from "./Icon.module.scss";
import { classNames } from "../../lib/classNames/classNames";
import { useFlexibleResponsiveValue } from "../../hooks/useResponsiveValue/useResponsiveValue";

/**
 * @typedef {Omit<React.SVGProps<SVGSVGElement>, "onClick">} SvgProps
 */

/**
 * @typedef {Object} IconBaseProps
 * @property {string} [className]
 * @property {React.FunctionComponent<React.SVGProps<SVGSVGElement>>} Svg
 * @property {number} [width]
 * @property {number} [height]
 */

/**
 * @typedef {IconBaseProps & { clickable?: false }} NonClickableIconProps
 */

/**
 * @typedef {IconBaseProps & { clickable: true, onClick: () => void }} ClickableIconProps
 */

/**
 * @typedef {NonClickableIconProps | ClickableIconProps} IconProps
 */

/**
 * @param {IconProps} props
 */
export const Icon = (props) => {
    const { className, Svg, width = 16, height = 16, clickable, ...otherProps } = props;

    const resolvedWidth = useFlexibleResponsiveValue(width);
    const resolvedHeight = useFlexibleResponsiveValue(height);

    if (clickable) {
        return (
            <button
                type="button"
                onClick={props.onClick}
                style={{ height, width }}
                className={classNames(cls.button, {}, [className])}
            >
                <Svg
                    className={cls.icon}
                    width={resolvedWidth}
                    height={resolvedHeight}
                    {...otherProps}
                    onClick={undefined}
                />
            </button>
        );
    }

    return (
        <Svg
            className={classNames(cls.icon, {}, [className])}
            width={resolvedWidth}
            height={resolvedHeight}
            {...otherProps}
            onClick={undefined}
        />
    );
};
